import type { FlowDocument } from "./types";

/**
 * Returns a new document with one node's `config` replaced.
 *
 * A pure, immutable update — React state can hand this straight to
 * `setDocument` without any other node or edge being touched. Only `config`
 * changes here; a node's `type` is fixed for this slice (changing type
 * would change the whole required config shape, which is editing work this
 * slice does not attempt).
 */
export function setNodeConfig(doc: FlowDocument, nodeId: string, config: unknown): FlowDocument {
  return {
    ...doc,
    nodes: doc.nodes.map((node) => (node.id === nodeId ? { ...node, config } : node)),
  };
}
